<!-- Dati riassuntivi gamification -->
<mat-card class="align-items-center">
    <div class="level-container">
        <div class="avatar image bg-white mt-3 rounded-circle">
            <div>
                
                <!-- Cerchio grigio di sfondo che fa da track -->
                <mat-spinner class="track level-progress" 
                    mode="determinate" 
                    value="100">
                </mat-spinner>

                <!-- Effettivo progresso del livello -->
                <mat-progress-spinner
                class="level-progress"
                color="primary"
                mode="determinate"
                [value]="gameData.progress_level">
                </mat-progress-spinner>
            </div>
            <p class="level m-0 text-center">{{ 'Lv. ' + gameData.level }}</p>
        </div>
    </div>
    <mat-card-header class="text-center pb-3">
        <mat-card-title>{{ gameData.total_points + ' pt.' }}</mat-card-title>
        <mat-card-subtitle class="mt-3">
            <span class="main-font" matTooltip="Posizione in classifica">{{ gameData.position + '°' }}</span>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="align-self-start col-12">
        <div class="d-flex justify-content-center text-center pt-4 pb-custom" *ngIf="gameData.last_achievements; else noAchievementBlock">
            <div *ngFor="let achievement of gameData.last_achievements" class="col-4 last-achievement">
                <img [src]="achievement.image_path" alt="Achievement" class="w-100" [matTooltip]="achievement.title" matTooltipPosition="above">
            </div>
        </div>
        <ng-template #noAchievementBlock>
            <div class="text-center align-content-center pt-4 pb-custom custom-height">
                Nessun achievement disponibile
            </div>
        </ng-template>
        <button mat-raised-button color="accent" class="col-12 game-button">Vai a gamification</button>
    </mat-card-content>
</mat-card>
